<template>
  <div class="head" :class="$route.meta.whiteTitle ? 'white-head' : ''" :style="{ background: scrollTop ? '#01072C' : 'transparent' }">
    <img class="logo" src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/logo.png" @click="goHome" alt="">
    <img v-if="!isPc" class="menu-icon" src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/menu.png" @click="showMenu = true" alt="">
    <img class="lang-en" v-show="!hiddenMenus.includes($route.path) && !['/activityExchange', '/mediaDetail'].includes($route.path)" @click="changeLang" src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/en.png" v-if="!isPc && !En" alt="">
    <div class="lang" v-show="!hiddenMenus.includes($route.path) && !['/activityExchange', '/mediaDetail'].includes($route.path)" @click="changeLang" v-if="!isPc && En">{{ En ? '中文' : 'EN' }}</div>
    <transition name="move">
        <ul class="menu" v-if="isPc || (!isPc && showMenu)">
            <li v-for="(item, index) in menus" :key="index" :class="isPc ? $route.meta.activeName === item.link ? 'active' : '' : showChildren ? 'active' : ''" v-show="!(En && item.hiddenEn)" @click="link(item)">
                {{ item['name' + En] }}
                <i class="el-icon-arrow-down" v-if="item.children && item.children.length"></i>
                
                <div class="menu-children" :class="En ? 'en' : ''" v-if="item.children && item.children.length">
                    <div class="item" @click="linkSub(ite)" v-for="(ite, ind) in item.children" :key="index + 'a' + ind" :class="$route.meta.activeNameSub === ite.link ? 'active' : ''">{{ ite['name' + En] }}</div>
                </div>
            </li>
            <li @click="changeLang" v-if="isPc" v-show="!hiddenMenus.includes($route.path) && !['/activityExchange', '/mediaDetail'].includes($route.path)">{{ En ? '中文' : 'EN' }}</li>
            <img v-if="!isPc" class="close-icon" src="https://inclusion.oss-cn-hangzhou.aliyuncs.com/static/images/mask-close.png" @click="showMenu = false" alt="">
        </ul>
    </transition>
    <transition name="fade">
        <div class="mask-menu" @click="showMenu = false" v-if="!isPc && showMenu"></div>
    </transition>
  </div>
</template>

<script>
import protal from "@/api/protal"

export default {
  name: 'Head',
  data() {
    return {
        showChildren: false,
        showMenu: false,
        scrollTop: 0,
        menus: [],
        hiddenMenus: []
    }
  },
  created() {
    protal.getJson('menu', data => {
        this.menus = data
        data.forEach(x => {
            if (x.hiddenEn) {
                this.hiddenMenus.push(x.link)
            }
            if (x.children) {
                x.children.forEach(y => {
                    if (y.hiddenEn) {
                        this.hiddenMenus.push(y.link)
                    }
                })
            }
        })
    })
  },
  mounted() {
    window.addEventListener('scroll', e => {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        this.scrollTop = scrollTop
    })
  },
  methods: {
    goHome() {
        this.$router.push('/')
    },
    link(item) {
        this.showChildren = !this.showChildren
        if (item.children && item.children.length) return
        this.$router.push(item.link)
        this.showMenu = false
    },
    linkSub(item) {
        this.$router.push(item.link)
        this.showMenu = false
    },
    changeLang() {
      let locale = this.$i18n.locale;
      locale === "ch" ? (this.$i18n.locale = "en") : (this.$i18n.locale = "ch");
      localStorage.setItem("lang", this.$i18n.locale);
    },
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
    .head {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100px;
        z-index: 100;
        transition: .5s;

        .logo {
            position: absolute;
            left: 168px;
            top: 28px;
            width: 153px;
            height: auto;
            cursor: pointer;
            transition: .5s;
        }

        .menu {
            position: absolute;
            right: 168px;
            top: 0;
            height: 100%;
            display: flex;
            transition: .5s;

            li {
                position: relative;
                margin-left: 48px;
                padding-top: 46px;
                font-family: AlibabaPuHuiTi_3_45_Light;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 20px;
                text-align: left;
                font-style: normal;
                cursor: pointer;
                transition: .5s;

                i {
                    transition: .5s;
                }

                .menu-children {
                    position: absolute;
                    left: 50%;
                    top: 80px;
                    transform: translateX(-50%);
                    width: 148px;
                    padding: 12px 0;
                    background: #000632;
                    border-radius: 12px;
                    opacity: 0;
                    transition: .3s linear;
                    pointer-events: none;
                    height: 0;
                    overflow: hidden;

                    &.en {
                        width: 400px;
                        left: 0;
                        transform: translateX(0);
                    }

                    .item {
                        padding-left: 20px;
                        line-height: 40px;
                        font-family: AlibabaPuHuiTi_2_65_Medium;
                        font-size: 16px;
                        color: #FFFFFF;
                        text-align: left;
                        font-style: normal;

                        &.active, &:hover {
                            color: #4D84FF;
                        }
                    }
                }

                &:hover {
                    .menu-children {
                        opacity: 1;
                        height: 184px;
                        pointer-events: auto;
                    }
                }

                &.active, &:hover {
                    color: #4D84FF;

                    i {
                        transform: rotateX(180deg);
                    }
                }
            }
        }

        &.white-head .menu li {
            &.active, &:hover {
                color: #fff;
                font-family: AlibabaPuHuiTi_3_65_Medium;
            }
        }
    }
}
@media screen and (max-width: 1470px) and (min-width: 768px) {
    .head {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100px;
        z-index: 100;
        transition: .5s;

        .logo {
            position: absolute;
            left: 88px;
            top: 32px;
            width: 120px;
            height: auto;
            cursor: pointer;
            transition: .5s;
        }

        .menu {
            position: absolute;
            right: 88px;
            top: 0;
            height: 100%;
            display: flex;
            transition: .5s;

            li {
                position: relative;
                margin-left: 20px;
                padding-top: 46px;
                font-family: AlibabaPuHuiTi_3_45_Light;
                font-size: 14px;
                color: #FFFFFF;
                line-height: 20px;
                text-align: left;
                font-style: normal;
                cursor: pointer;
                transition: .5s;

                i {
                    transition: .5s;
                }

                .menu-children {
                    position: absolute;
                    left: 50%;
                    top: 80px;
                    transform: translateX(-50%);
                    width: 148px;
                    padding: 12px 0;
                    background: #000632;
                    border-radius: 12px;

                    .item {
                        padding-left: 20px;
                        line-height: 40px;
                        font-family: AlibabaPuHuiTi_2_65_Medium;
                        font-size: 12px;
                        color: #FFFFFF;
                        text-align: left;
                        font-style: normal;

                        &.active, &:hover {
                            color: #4D84FF;
                        }
                    }
                }

                &:hover {
                    .menu-children {
                        display: block;
                    }
                }

                &.active, &:hover {
                    color: #4D84FF;

                    i {
                        transform: rotateX(180deg);
                    }
                }
            }
        }
    }
}
@media screen and (max-width: 767px) {
    .head {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 66px;
        z-index: 100;
        transition: .5s;

        .logo {
            position: absolute;
            left: 18px;
            top: 18px;
            width: auto;
            height: 36px;
            cursor: pointer;
        }

        .menu-icon {
            position: absolute;
            right: 20px;
            top: 21px;
            width: 30px;
        }

        .lang-en {
            position: absolute;
            right: 70px;
            top: 21px;
            width: 30px;
            color: #fff;
        }

        .lang {
            position: absolute;
            right: 72px;
            top: 26px;
            font-size: 20px;
            color: #fff;
            line-height: 1;
            font-family: inClusionFont;
        }

        .mask-menu {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            height: 100vh;
            background: rgba(0, 0, 0, 0.4);
        }

        .menu {
            position: absolute;
            left: 70px;
            right: 0;
            top: 0;
            height: 100vh;
            background: #000632;
            padding: 107px 0 0 30px;
            z-index: 1;

            &::before {
                content: "";
                position: absolute;
                top: 66px;
                left: 0;
                right: 0;
                border-bottom: 1px solid rgba(255, 255, 255, 0.2);
            }

            li {
                font-family: AlibabaPuHuiTi_3_85_Bold;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 18px;
                text-align: left;
                font-style: normal;
                margin-bottom: 30px;
                font-weight: normal;
                position: relative;

                .menu-children {
                    padding-top: 24px;
                    display: none;

                    .item {
                        margin-bottom: 24px;
                        font-family: AlibabaPuHuiTi_3_45_Light;
                        font-size: 15px;
                        color: rgba(255, 255, 255, 0.8);
                        line-height: 15px;
                        text-align: left;
                        font-style: normal;
                        padding-left: 10px;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        &.active {
                            // color: #4D84FF;
                        }
                    }
                }

                &.active {
                    // color: #4D84FF;

                    .menu-children {
                        display: block;
                    }
                }

                i {
                    position: absolute;
                    right: 28px;
                    top: 0;
                    transition: .5s;
                }

                &.active {
                    // color: #4D84FF;

                    i {
                        transform: rotateX(180deg);
                    }
                }
            }

            .close-icon {
                position: absolute;
                right: 20px;
                top: 24px;
                width: 30px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue